import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Drawer from '../Common/Drawer/Drawer';
import Toggle from '../Common/Toggle/Toggle';

export default class ColumnFiltersDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            values: []
        }

    }

    componentDidMount = () => {
        // merge and saved with master list
        let newValues = [];
        for(let i = 0; i < this.props.filters.masterColumns.length; i++){
            const masterColumn = this.props.filters.masterColumns[i];
            const savedColumn = this.props.filters.savedColumns.find(m => m.fieldName === masterColumn.fieldName);

            // do we show the toggle?
            const enabled = this.isColumnFeatureEnabled(masterColumn.fieldName);

            if(enabled){

                // we show the toggle as checked if there is a saved record found
                // or if there are no savedColumns for that user and the default is true for the the master
                let isDefault = (this.props.filters.savedColumns.length === 0) ? masterColumn.isDefault : false;
                let isSaved = (savedColumn) ? true : isDefault;
                const option = {
                    id: masterColumn.columnId,
                    displayName: masterColumn.displayName,
                    fieldName: masterColumn.fieldName,
                    isSaved: isSaved
                };
                newValues.push(option);  
            }
        }
        this.setState({ values: newValues });
    }

    isColumnFeatureEnabled = (fieldName) => {
        // determines if the columns should be shown based on special rules
        switch(fieldName){
            case "projectName":
                return this.props.filters.isProjectWidgetActive;
            case "startDate":
                return this.props.filters.isStartDateActive;
            case "steps":
                return this.props.filters.isTaskStepsActive;
            case "prereqs":
                return this.props.filters.isTaskDependenciesActive;
            default:
                return true;
        }
    }

    onSave = async () => {
        let arrayOfColumnIds = [];
        for(let i = 0; i < this.state.values.length; i++){
            if(this.state.values[i].isSaved){
                arrayOfColumnIds.push(this.state.values[i].id);
            }
        }
        this.props.onComplete(arrayOfColumnIds);
    }

    onToggleChange = (name, value) => {
        const newValues = this.state.values.slice();
        const valueItem = this.state.values.find(m => m.displayName === name);

        valueItem.isSaved = value;

        this.setState({ values : newValues});

    }

    render() {

        const additionalDrawerButtons = [<button key="reset" type="button" className="drawer-button btn btn-warning button--cancel" onClick={this.props.onReset}>Reset</button>];

        return (
            <Drawer isOpen={true} isWide={false} title='Columns'
                onSaveClick={this.onSave}
                saveText='Save'
                onCancelClick={this.props.onCancel}
                formButtons={additionalDrawerButtons}
                >
                {this.state.values.map(column => 
                    <div key={column.fieldName}><Toggle name={column.displayName} text={column.displayName} checked={column.isSaved} onChange={this.onToggleChange} /></div>
                )}
            </Drawer>
        )
    }
}

ColumnFiltersDrawer.propTypes = {
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    searchParams: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    locationTasks: PropTypes.array.isRequired
};
